import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { DocumentDetail, DocumentsList } from '@/features/documents';
import { Dashboard } from '@/features/dashboard';
import {
  AnalysesList,
  AnalysisDetail,
  CreateAnalysis
} from '@/features/analyses';

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/documents" element={<DocumentsList />} />
        <Route path="/documents/:sourceUrl" element={<DocumentDetail />} />
        <Route path="/analyses" element={<AnalysesList />} />
        <Route path="/analyses/create" element={<CreateAnalysis />} />
        <Route path="/analyses/:analysisId" element={<AnalysisDetail />} />
        <Route path="*" element={<div> Not Found </div>} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
